/**
 * Warstwa API: LISTA DOZWOLONYCH LOGOWAŃ („whitelista”) per firma (polecenie właściciela 2026-10-04).
 *
 * Właściciel: „admin może włączyć whitelistę i te osoby dodać, albo wyłączyć i wtedy każdy loguje się z danego tenanta do
 * aplikacji”. Lista wyłączona = logowanie jak dotąd. Włączona = przez Office 365 wchodzą tylko osoby z listy; administrator
 * aplikacji wchodzi zawsze, konto logujące się hasłem (spoza Office 365) liście nie podlega.
 *
 * Trasy backendu (ListaLogowanController, `api/lista-logowan`) — wszystkie dla osoby z dostępem do integracji:
 *  - `GET` — `{ spolki[{ companyId, nazwa, domeny[], wspolnyTenantZ[], wlaczona, od, ktoNazwa, naLiscie, kontaO365, bezDostepu,
 *    administratorzy, kontaLokalne, ostrzezenia[] }], firmyBezTenanta[], kontaO365BezFirmy }`;
 *  - `GET {companyId}/wpisy` — osoby na liście: `{ id, userId, adres, nazwa, opis, stanKod, stan, dodalNazwa, dodanoAt, ostatnieLogowanie }`;
 *  - `GET {companyId}/kandydaci?q=` — kogo można dodać: `{ id („u:<konto>” albo „a:<adres>”), nazwa, stanowisko, dzial, email, userId, stan }`;
 *  - `GET {companyId}/skutki` — `{ naLiscie, bezDostepu, osoby[] }` (kto straci dostęp po włączeniu);
 *  - `GET {companyId}/odmowy?dni=7` — `{ adres, liczba, ostatnio }`;
 *  - `PUT {companyId}` `{ wlaczona, potwierdzamPustaListe }` — przełącznik; 409 = pusta lista bez potwierdzenia albo firma bez tenanta;
 *  - `POST {companyId}/wpisy` `{ userId | adres }` — dodanie osoby; 400 z powodem (inna firma, konto lokalne, adres spoza tenanta);
 *  - `DELETE {companyId}/wpisy/{id}` — usunięcie osoby.
 *
 * PIN ADMINISTRATORA: zapisy stoją za RequireAdminPinFilter — odmowę 403 `admin_pin_required` przechwytuje interceptor
 * w apiService.js, otwiera okno PIN-u i ponawia żądanie jeden raz.
 */
export function attach(api) {
    return {
        pobierzListeLogowan: () => api.get("/lista-logowan"),
        pobierzWpisyListyLogowan: (companyId) => api.get(`/lista-logowan/${companyId}/wpisy`),
        szukajKandydatowListyLogowan: (companyId, q) => api.get(`/lista-logowan/${companyId}/kandydaci`, { params: { q: q || "" } }),
        pobierzSkutkiListyLogowan: (companyId) => api.get(`/lista-logowan/${companyId}/skutki`),
        pobierzOdmowyListyLogowan: (companyId, dni = 7) => api.get(`/lista-logowan/${companyId}/odmowy`, { params: { dni } }),
        ustawListeLogowan: (companyId, wlaczona, potwierdzamPustaListe = false) =>
            api.put(`/lista-logowan/${companyId}`, { wlaczona: wlaczona === true, potwierdzamPustaListe: potwierdzamPustaListe === true }),
        dodajDoListyLogowan: (companyId, osoba) => api.post(`/lista-logowan/${companyId}/wpisy`, osoba),
        usunZListyLogowan: (companyId, id) => api.delete(`/lista-logowan/${companyId}/wpisy/${id}`),
    };
}
